import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import MyStoreCheckout from '../components/MyStoreCheckout'

function IndexPage() {
  return (
    <Layout>
      <SEO title="Donate" keywords={[`Everybody Eats`]} />
      <h1 className="font-serif text-4xl mb-4">
        Pay <span className="ring">as you feel</span>
      </h1>
      <p className="mb-12 text-sm">
        Thanks for joining us tonight at Everybody Eats. We appreciate your
        support! For every additional $10 we can feed two more people that
        can't afford to pay.
      </p>

      <MyStoreCheckout />
      <a
        href="https://everybodyeats.nz/faqs"
        className="text-xs mt-4 text-center text-grey-dark"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
    </Layout>
  )
}

export default IndexPage
